import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, TrendingUp, Sparkles, Coins, Bot, FileText, Activity, MoreHorizontal, Briefcase } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import SidebarNav from "./SidebarNav";

const PRIMARY_NAV = [
  { to: "/dashboard", label: "Overview", icon: LayoutDashboard, testId: "mobnav-dashboard" },
  { to: "/stocks", label: "Stocks", icon: TrendingUp, testId: "mobnav-stocks" },
  { to: "/portfolio", label: "Portfolio", icon: Briefcase, testId: "mobnav-portfolio" },
  { to: "/best-value", label: "Best Val", icon: Sparkles, testId: "mobnav-best-value" },
];

const MobileBottomNav = () => {
  const [moreOpen, setMoreOpen] = useState(false);

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-30 bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/80 border-t border-border"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-5">
        {PRIMARY_NAV.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testId}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-medium transition-colors duration-150 ${
                  isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
                }`
              }
            >
              <Icon className="h-5 w-5" />
              {item.label}
            </NavLink>
          );
        })}
        <Sheet open={moreOpen} onOpenChange={setMoreOpen}>
          <SheetTrigger asChild>
            <button
              data-testid="mobnav-more"
              className="flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-medium text-muted-foreground hover:text-foreground"
            >
              <MoreHorizontal className="h-5 w-5" />
              More
            </button>
          </SheetTrigger>
          <SheetContent side="left" className="w-[280px] p-0">
            <SidebarNav onNavigate={() => setMoreOpen(false)} />
          </SheetContent>
        </Sheet>
      </div>
    </nav>
  );
};

export default MobileBottomNav;
